export enum ActionIconType {
  ANNOTATION_TOOL_PANEL = 'AnnotationToolPanel',
  COST_AND_QUALITY_PANEL = 'CostAndQualityPanel',
  DEFAULT = '',
  LABS_HISTORY_PANEL = 'LabsHistoryPanel',
  PATIENT_GOALS_PANEL = 'PatientGoalsPanel',
  PATIENT_INFO_PANEL = 'PatientInfoPanel',
  PLAN_PLAYBOOK_PANEL = 'PlanPlaybookPanel',
  PROVIDER_BIO_PANEL = 'ProviderBioPanel',
  PROVIDER_NOTES_PANEL = 'ProviderNotesPanel',
}

export enum BannerState {
  DEFAULT = 'DEFAULT',
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS',
  WARNING = 'WARNING',
}

export enum ChimeEvent {
  ATTENDEE_DROPPED = 'Attendee dropped',
  ATTENDEE_ENDED_CALL = 'Attendee ended call',
  ATTENDEE_PRESENCE_RECEIVED = 'Attendee joined meeting with microphone',
  AUDIO_INPUT_FAILED = 'Audio input failed',
  AUDIO_INPUT_SELECTED = 'Audio input selected',
  AUDIO_VIDEO_RECONNECTING = 'Audio/Video reconnecting',
  AUDIO_VIDEO_STARTED = 'Audio/Video started',
  AUDIO_VIDEO_STOPPED = 'Audio/Video stopped',
  CONNECTION_BECAME_POOR = 'Connection became poor',
  CONNECTION_SUGGESTED_VIDEO_STOP = 'Connection suggested video stop',
  MEETING_ENDED = 'Meeting ended',
  MEETING_FAILED = 'Meeting failed',
  MEETING_RECONNECTED = 'Meeting reconnected',
  MEETING_START_FAILED = 'Meeting start failed',
  MEETING_START_REQUESTED = 'Meeting start requested',
  MEETING_START_SUCCEEDED = 'Meeting start succeeded',
  RECEIVING_AUDIO_DROPPED = 'Signification number of receive-audio packets dropped',
  SENDING_AUDIO_RECOVERED = 'Sending audio packets successful after failure',
  SIGNAL_DROPPED = 'Websocket failed or closed w/ error',
  VIDEO_AVAILABILITY_CHANGED = 'Video availability changed',
  VIDEO_INPUT_FAILED = 'Video input failed',
  VIDEO_INPUT_SELECTED = 'Video input selected',
  VIDEO_SEND_BECAME_UNAVAILABLE = 'Video send became unavailable',
}

export enum EncounterAction {
  Complete = 'complete',
  Default = '',
  Dismiss = 'dismiss',
  DoctorsNote = 'doctorsNote',
  Edit = 'edit',
  NonBillable = 'nonBillable',
  NonBillableMessage = 'nonBillableMessage',
  Release = 'release',
  Transfer = 'transfer',
  VideoNow = 'videoNow',
}
export enum EncounterMetaAction {
  ADMIN_DELETE_MESSAGE = 'admin delete message',
  ADMIN_DISMISS = 'admin dismiss',
  AUTO_ASSIGN = 'auto assign',
  CANCEL = 'cancel',
  CLAIM = 'claim',
  CLOSE = 'close',
  DISMISS = 'dismiss',
  PROVIDER_DELETE_MESSAGE = 'provider delete message',
  RELEASE = 'release',
  STREAM_RELOAD = 'stream reload',
  TRANSFER = 'transfer',
  UPDATE_PATIENT = 'update patient',
}

export enum EncounterState {
  ACTIVE = 'active',
  ASSIGNED = 'assigned',
  COMPLETED = 'completed',
  DISMISSED = 'dismissed',
  HOT = 'hot',
  UNASSIGNED = 'unassigned',
  UNRESOLVED = 'unresolved',
}

export enum InferenceCategory {
  PLAYBOOK = 'playbook',
}

export enum LabOrderCardAction {
  SHARE = 'share',
  VIEW_PDF = 'viewPdf',
}

export enum LocalStorageSensitivity {
  NON_PHI = 'not private health information',
  PHI = 'private health information',
}

export enum MessageType {
  ASSESSMENT_RESULT = 'AssessmentResult',
  ENCOUNTER = 'Encounter',
  ERROR = 'Error',
  MESSAGE = 'Message',
  PRE_ENCOUNTER_ALERT = 'PreEncounterAlert',
  PROGRESS = 'Progress',
  UNIVERSAL = 'Universal',
}

export enum PanelName {
  ENCOUNTER_INFO_PANEL = 'encounterInfoPanel',
  SIDE_PANEL = 'sidePanel',
}

export enum PlaybookSources {
  LLM = 'llm_playbook',
  STATIC = 'static_playbook',
}

export enum UserTrackingTypes {
  DEPENDENT = 'dependent',
  PATIENT = 'patient',
  PROVIDER = 'provider',
}

export enum UserTypeNames {
  DEPENDENT = 'PatientDependent',
  PATIENT = 'Patient',
  PROVIDER = 'Provider',
}

export enum PrescreenInputType {
  STATE_DROPDOWN = 'state_dropdown',
  TEXT = 'text',
  FORM = 'form',
  BUTTON = 'button',
}

export enum ProviderFilter {
  ALL = 'all_providers',
  ON_SHIFT = 'on_shift',
}

export enum ShiftState {
  OFF_DUTY = 'off_duty',
  ON_CALL = 'on_call',
  ON_DUTY = 'on_duty',
}

export enum QuestionType {
  BINARY = 'binary',
  STAR = 'star',
  TEXT = 'text',
}

export enum QueueStatusEnum {
  OFF_HOURS = 'off-hours',
  PRE_ASSIGNED = 'pre-assigned',
  SUBSCRIBER_VERIFY = 'subscriber-verify',
}

export enum QueueStatusType {
  ONBOARDING = 'onboarding',
}

export enum EventKey {
  ARROW_DOWN = 'ArrowDown',
  ARROW_UP = 'ArrowUp',
  ENTER = 'Enter',
}

export enum VideoSessionType {
  AwsChime,
}
